import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import {getNotifications, updateNotification} from "services/notificationServices";
import profileImg from "assets/images/profile-img.png";
import "./NotificationSidebar.css";
import ToggleSwitch from "./ToggleSwitch"

const NotificationSidebar = ({isOpen, onClose, onNotificationUpdate}) => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const {user} = useSelector((state) => state.Profile);
    const sidebarRef = useRef(null);
    const [markAllRead, setMarkAllRead] = useState(false);

    // Fetch notifications only for the current user that are unread
    useEffect(() => {
        if (isOpen) {
            const fetchNotifications = async () => {
                try {
                    setLoading(true);
                    const response = await getNotifications();
                    const filteredNotifications = (response.data || []).filter(
                        (notification) => notification.user_id === user.id && !notification.is_read
                    );
                    setNotifications(filteredNotifications);
                } catch (error) {
                    console.error("Error fetching notifications:", error);
                } finally {
                    setLoading(false);
                }
            };

            fetchNotifications();
        }
    }, [isOpen, user.id]);

    // Close sidebar when clicking outside of it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);


  // Reset toggle when sidebar closes
    useEffect(() => {
        if (!isOpen) {
            setMarkAllRead(false);
        }
    }, [isOpen]);

    // Mark a single notification as read, remove it from the list, and trigger the update callback
    const handleMarkAsRead = async (notificationId) => {
        try {
            await updateNotification(notificationId, {is_read: true});
            setNotifications((prev) =>
                prev.filter((notification) => notification.id !== notificationId)
            );
            if (onNotificationUpdate) {
                onNotificationUpdate();
            }
        } catch (error) {
            console.error("Error marking notification as read:", error);
        }
    };

    // Toggle Mark All as Read: mark every visible notification as read and clear the list
    const handleMarkAllToggle = async () => {
        const newMarkAllRead = !markAllRead;
        setMarkAllRead(newMarkAllRead);
        if (newMarkAllRead) {
            try {
                await Promise.all(
                    notifications.map((n) =>
                        updateNotification(n.id, {is_read: true})
                    )
                );
                setNotifications([]);
                if (onNotificationUpdate) {
                    onNotificationUpdate();
                }
            } catch (error) {
                console.error("Error marking all notifications as read:", error);
            }
        }
    };

    return (
        <div className={`notification-sidebar ${isOpen ? "open" : ""}`} ref={sidebarRef}>
            <div className="sidebar-header d-flex justify-content-between align-items-center p-3">
                <h5>Notifications</h5>
                <button className="close-button" onClick={onClose}>
                    {/* &times; */}
                    <i className="fas fa-times-circle"></i>
                </button>
                {/* <div className="toggle-switch d-flex align-items-center">
        <span className="toggle-text">Mark all notifications as read</span>
          <label className="switch">
            <input
              type="checkbox"
              checked={markAllRead}
              onChange={handleMarkAllToggle}
            />
            <span className="slider round"></span>
          </label>
          
        </div> */}
            </div>

            <div className="sidebar-content p-3">
                <ToggleSwitch
                    label="Mark all notifications as read:"
                    defaultChecked={markAllRead}
                    onChange={handleMarkAllToggle}
                />
                {/*<div className="d-flex align-items-center justify-content-between">*/}
                {/*  <span className="toggle-text">Mark all notifications as read</span>*/}
                {/*  <label className="switch">*/}
                {/*    <input*/}
                {/*      type="checkbox"*/}
                {/*      checked={markAllRead}*/}
                {/*      onChange={handleMarkAllToggle}*/}
                {/*    />*/}
                {/*    <span className="slider round"></span>*/}
                {/*  </label>*/}

                {/*</div>*/}
                {loading ? (
                    <p>Loading notifications...</p>
                ) : notifications.length > 0 ? (
                    notifications.map((notification) => (
                        <div
                            key={notification.id}
                            className={`notification-card ${notification.is_read ? "read" : "unread"}`}
                            onClick={() => handleMarkAsRead(notification.id)}
                        >
                            <div className="notification-header d-flex align-items-center">
                                <img
                                    src={profileImg}
                                    alt="Profile"
                                    className="notification-profile"
                                />
                                <div className="notification-info">
                                    <strong>
                                        {`${notification.created_by.first_name} ${notification.created_by.last_name}`}
                                    </strong>
                                    <a
                                        href={notification.resource_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="notification-message"
                                    >
                                        {notification.message}
                                    </a>
                                    <span
                                        className={`status-dot ${notification.is_read ? "green-dot" : "red-dot"}`}></span>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                {/* Added the 'timestamp' class to adjust left margin via CSS */}
                                <small className="text-muted timestamp">
                                    {notification.last_updated}
                                </small>
                                <span className={`tag ${notification.entity_type}`}>
                  {notification.entity_type === "e_tracker" ? "E-Tracker" : notification.entity_type}
                </span>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-muted pt-3">No notifications available.</p>
                )}
            </div>
        </div>
    );
};

NotificationSidebar.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onNotificationUpdate: PropTypes.func,
};

export default NotificationSidebar;